// import { ssoUrl } from "@/constants";
// import { set, isEmpty } from "lodash";
// import { authApi } from "./auth";
// import { setUserDataInSharedStorage } from "./cookies";

// import { loadRefreshToken, loadToken, saveTokens } from "./storage";

// interface ITomService {
//   url: string;
//   method: string;
//   body?: any;
//   third_party?: boolean;
//   formData?: boolean;
// }

// interface IReqBody {
//   method: string;
//   headers: any;
//   body?: any;
// }

// const black_list = "/login/";

// const handleErrors = (
//   json: any,
//   url: string,
//   third_party: boolean | undefined
// ) => {
//   if (third_party) {
//     return {
//       data: json,
//     };
//   }
//   if (!json.success) throw json;

//   if (url.includes(black_list)) {
//     const tokens = json?.data?.token;
//     saveTokens(tokens);
//   }

//   return {
//     data: {
//       data: json?.data,
//       pagination: json?.pagination,
//       message: json?.message,
//     },
//   };
// };

// export const tomService =
//   ({ baseUrl } = { baseUrl: "" }) =>
//   async ({ url, third_party, method, body, formData }: ITomService) => {
//     const headers = {};

//     let path = third_party ? url : `${baseUrl}${url}`;
//     if (!formData) {
//       set(headers, "Accept", "application/json");
//       set(headers, "Content-Type", "application/json");
//     }
//     let accessToken = loadToken();

//     if (!url.includes(black_list) && accessToken && !third_party) {
//       set(headers, "Authorization", `Bearer ${accessToken}`);
//     }

//     const reqBody: IReqBody = {
//       method,
//       headers,
//     };

//     if (formData) {
//       reqBody.body = body;
//     }
//     if (body && !isEmpty(body) && !formData) {
//       reqBody.body = JSON.stringify(body);
//     }

//     try {
//       let res = await fetch(path, reqBody);
//       if (res.headers.get("Content-Type") === "text/csv") {
//         const blob = await res.blob();
//         const url = window.URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         const filename = res.url.split("/");
//         a.href = url;
//         a.download = `${filename[filename.length - 3]}.csv`;
//         document.body.appendChild(a);
//         a.click();
//         a.remove();
//         return { data: [] };
//       } else {
//         const json = await res.json();
//         const isVerifyCall = res.url.includes("/v2/auth/verify-user/");
//         let refreshed = false;
//         if (
//           json.code === 5000 ||
//           (json.code === 1002 && json.message === "Invalid Token")
//         ) {
//           await new Promise(async (res, rej) => {
//             const refresh = loadRefreshToken();
//             const reqHeaders: any = { ...headers };
//             delete reqHeaders["Authorization"];
//             if (refresh) {
//               const res = await fetch(
//                 `${process.env.REACT_APP_BASE_URL}/auth/refresh-token/`,
//                 {
//                   method: "POST",
//                   headers: reqHeaders,
//                   body: JSON.stringify({
//                     refresh,
//                   }),
//                 }
//               );
//               const json = await res.json();
//               if (json.message === "Invalid Token" || !json.success) {
//                 window.store.dispatch(
//                   authApi.endpoints.logout.initiate({ refresh })
//                 );
//                 localStorage.clear();
//                 window.open(ssoUrl, "_self");
//                 return;
//               }
//               if (isVerifyCall) {
//                 // if token in cookies is expired. refresh the token and update it in cookies.
//                 setUserDataInSharedStorage({
//                   access: json.data.access,
//                   refresh,
//                 });
//               }
//               saveTokens({ access: json.data.access, refresh });
//               set(headers, "Authorization", `Bearer ${json.data.access}`);
//               refreshed = true;
//             }
//             res(true);
//           });
//           if (refreshed) {
//             let res = await fetch(path, reqBody);
//             let json = await res.json();
//             refreshed = false;
//             return handleErrors(json, url, third_party);
//           }
//         }
//         return handleErrors(json, url, third_party);
//       }
//       console.log("right  ")
//     } catch (error) {
//       let err = error;
//       return {
//         error: {
//           success: err?.success,
//           message: err?.message,
//           error: err?.error,
//           code: err?.code,
//           data: err?.data,
//           is_validation_error: err?.is_validation_error,
//         },
//       };
//     }
//   };

import { ssoUrl } from "@/constants";
import { set, isEmpty } from "lodash";
import { authApi } from "./auth";
import { setUserDataInSharedStorage } from "./cookies";
import { loadRefreshToken, loadToken, saveTokens } from "./storage";

interface ITomService {
  url: string;
  method: string;
  body?: any;
  third_party?: boolean;
  formData?: boolean;
}

interface IReqBody {
  method: string;
  headers: any;
  body?: any;
}

export const tomService =
  ({ baseUrl } = { baseUrl: "" }) =>
  async ({ url, third_party, method, body, formData }: ITomService) => {
    const headers = {};
    const black_list = "/login/";

    const handleErrors = (
      json: any,
      url: string,
      third_party: boolean | undefined
    ) => {
      if (third_party) {
        return {
          data: json,
        };
      }

      // ✅ Fix: Treat response as success even if 'success' field is missing
      const isSuccess = json.success === undefined ? true : json.success;

      if (!isSuccess) throw json;

      if (url.includes(black_list)) {
        const tokens = json?.data?.token;
        saveTokens(tokens);
      }

      return {
        data: {
          data: json?.data ?? json,
          pagination: json?.pagination,
          message: json?.message,
        },
      };
    };

    let path = third_party ? url : `${baseUrl}${url}`;
    if (!formData) {
      set(headers, "Accept", "application/json");
      set(headers, "Content-Type", "application/json");
    }
    let accessToken = loadToken();

    if (!url.includes(black_list) && accessToken && !third_party) {
      set(headers, "Authorization", `Bearer ${accessToken}`);
    }

    const reqBody: IReqBody = {
      method,
      headers,
    };

    if (formData) {
      reqBody.body = body;
    } else if (body && !isEmpty(body)) {
      reqBody.body = JSON.stringify(body);
    }

    try {
      let res = await fetch(path, reqBody);

      // ✅ Handle CSV case
      if (res.headers.get("Content-Type") === "text/csv") {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        const filename = res.url.split("/");
        a.href = url;
        a.download = `${filename[filename.length - 3]}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        return { data: [] };
      }

      // ✅ Handle non-JSON response safely
      const contentType = res.headers.get("Content-Type");
      if (!contentType?.includes("application/json")) {
        const rawText = await res.text();
        console.warn("⚠️ Non-JSON response from server:", rawText.slice(0, 300));
        return {
          error: {
            success: false,
            message: "Non-JSON response from server",
            raw: rawText,
          },
        };
      }

      const json = await res.json();
      // console.log("✅ Parsed JSON:", json);

      const isVerifyCall = res.url.includes("/v2/auth/verify-user/");
      let refreshed = false;

      if (
        json.code === 5000 ||
        (json.code === 1002 && json.message === "Invalid Token")
      ) {
        await new Promise(async (res, rej) => {
          const refresh = loadRefreshToken();
          const reqHeaders: any = { ...headers };
          delete reqHeaders["Authorization"];

          if (refresh) {
            const res = await fetch(
              `${process.env.REACT_APP_BASE_URL}/auth/refresh-token/`,
              {
                method: "POST",
                headers: reqHeaders,
                body: JSON.stringify({ refresh }),
              }
            );
            const json = await res.json();

            if (json.message === "Invalid Token" || !json.success) {
              window.store.dispatch(
                authApi.endpoints.logout.initiate({ refresh })
              );
              localStorage.clear();
              window.open(ssoUrl, "_self");
              return;
            }

            if (isVerifyCall) {
              setUserDataInSharedStorage({
                access: json.data.access,
                refresh,
              });
            }

            saveTokens({ access: json.data.access, refresh });
            set(headers, "Authorization", `Bearer ${json.data.access}`);
            refreshed = true;
          }

          res(true);
        });

        if (refreshed) {
          const res = await fetch(path, reqBody);
          const json = await res.json();
          refreshed = false;
          return handleErrors(json, url, third_party);
        }
      }

      return handleErrors(json, url, third_party);
    } catch (error) {
      let err = error;
      console.error("❌ Error caught in tomService:", err);
      return {
        error: {
          success: err?.success,
          message: err?.message || "Unknown error",
          error: err?.error,
          code: err?.code,
          data: err?.data,
          is_validation_error: err?.is_validation_error,
        },
      };
    }
  };

